module.exports = __webpack_public_path__ + "static/media/compose_private_message_2x.f54ed9c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brite/compose_private_message_2x.png
// module id = 287
// module chunks = 0